// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2kXtL","legacyBtn":"MutateMid_legacyBtn__2PO3L"};